import React from 'react'
import PropTypes from 'prop-types'
import { Typography } from '@chilecompra/react-kit/components'
import { Divider, Grid, Link } from './AttachFiles.styles'

/**
 * The AttachedFiles's component.
 */
const AttachedFiles = props => {
  const { divider, id, margin, name, onDeleteFile, onDownloadFile } = props
  const handleDeleteFile = () => onDeleteFile(id)
  const handleDownloadFile = () => onDownloadFile({ id, name })

  return (
    <>
      <Grid container margin={margin}>
        <Grid item sm={8} xs={12}>
          <Typography color="black1" fontSize="14px" lineHeight="28px" variant="body2">
            {name}
          </Typography>
        </Grid>
        {onDownloadFile && (
          <Grid item sm={2} xs={12}>
            <Link onClick={handleDownloadFile}>Descargar</Link>
          </Grid>
        )}
        {onDeleteFile && (
          <Grid item sm xs={12}>
            <Link onClick={handleDeleteFile}>Eliminar</Link>
          </Grid>
        )}
      </Grid>
      <Grid container>
        <Grid item xs>
          {divider && <Divider />}
        </Grid>
      </Grid>
    </>
  )
}

AttachedFiles.defaultProps = {
  margin: '8px 0'
}

AttachedFiles.propTypes = {
  divider: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
  margin: PropTypes.string,
  name: PropTypes.string.isRequired,
  onDeleteFile: PropTypes.func,
  onDownloadFile: PropTypes.func
}

export default AttachedFiles
